import Combobox from '@standardsdigital/ui-components/Combobox';
import type {
  ComboboxAnnouncementTexts,
  ComboboxOption,
} from '@standardsdigital/ui-components/Combobox';
import { useTranslation } from 'react-i18next';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';
import {
  addSelectedValue,
  messageSeverity,
  removeNumberValues,
} from './formInputHelpers';

interface ServicesSelectProps {
  options: ComboboxOption[];
  selectedOptions: ComboboxOption[];
  value: number[];
  onChange: (value: number[]) => void;
  announcementTexts: ComboboxAnnouncementTexts;
  error?: string;
  isDirty: boolean;
  disabled: boolean;
}

function ServicesSelect({
  options,
  selectedOptions,
  value,
  onChange,
  announcementTexts,
  error,
  isDirty,
  disabled,
}: Readonly<ServicesSelectProps>) {
  const { t } = useTranslation();

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <Combobox
        label={t('serviceLevels.form.services')}
        options={options}
        selectedOptions={selectedOptions}
        selection="tags"
        selectionModeLabel={t('serviceLevels.form.services')}
        announcementTexts={announcementTexts}
        clearButtonText={t('general.clearSearch')}
        required
        inputProps={{
          id: 'documentServices',
          name: 'documentServices',
          message: error,
          severity: messageSeverity(error),
        }}
        onSelect={(option) =>
          onChange(addSelectedValue(value, Number(option.value)))
        }
        onRemove={(optionsToRemove) =>
          onChange(removeNumberValues(value, optionsToRemove))
        }
        disabled={disabled}
      />
    </FieldStatusWrapper>
  );
}

export default ServicesSelect;
